"use client";

import React from "react";
import RouteError from "@/app/components/RouteError";

export default function StylistProfileError(props: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <RouteError
      {...props}
      title="We couldn't load this stylist"
      description="There was a problem loading this stylist's profile. Please try again, or browse our full team."
    />
  );
}
